export default "__VITE_ASSET__BlVC021x__"